export default function NotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-ink text-center">
      <h1 className="pixel-heading text-2xl text-magenta">404</h1>
      <p className="text-mist/70">GAME OVER — this level doesn't exist.</p>
    </div>
  );
}
